// extracted by mini-css-extract-plugin
export default {"flexyGridList":"_1ZzyPYVQbP5KExUke1Veez","gridList":"_24Ga_FpUeWSBwBVxqZl648"};